// extracted by mini-css-extract-plugin
export default {"size-badge":"size-badge__size-badge___7a1re","size-badge-oe":"size-badge__size-badge-oe___2scUP"};